import { render, staticRenderFns } from "./NfcTestPage.vue?vue&type=template&id=786fc900&"
import script from "./NfcTestPage.vue?vue&type=script&lang=ts&"
export * from "./NfcTestPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports